<script>
    export let allergens = [];
    export let selected = [];
    export let preferences = [];

    const food_preferences = ['Vegetarian', 'Vegan', 'Gluten free', 'Lactose free'];

    function isSelected(label) {
        return selected.indexOf(label) !== -1;
    }

    function toggle(label) {
        if (isSelected(label)) {
            selected = selected.filter((item) => item !== label);
        } else {
            selected = [...selected, label];
        }
    }

    const toggleFood = (value) => {
        if (preferences.indexOf(value) !== -1) {
            preferences = preferences.filter((item) => item !== value);
        } else {
            preferences = [...preferences, value];
        }
    }
</script>

<div class="grid form-group" role="group" aria-label="Allergen selector">
    {#each allergens as allergen (allergen.label)}
        <button
                type="button"
                class:item={true}
                class:selected={selected.includes(allergen.label)}
                aria-pressed={selected.includes(allergen.label)}
                on:click={() => toggle(allergen.label)}
        >
            <span class="icon" aria-hidden="true">
                <img src={`/assets/images/allergens/${allergen.file}`} alt=""/>
            </span>
            <span class="label">{allergen.label}</span>
            <span class="check" aria-hidden="true">
                <span class="check-inner"></span>
            </span>
        </button>
    {/each}
</div>

<div class="mb-5">
    <div class="text-gray small mb-1">Personal Preferences</div>
    {#each food_preferences as item, index}
        <div class="form-check">
            <input class="form-check-input" type="checkbox" id="checkPref{index}" on:click={() => toggleFood(item)}>
            <label class="form-check-label" for="checkPref{index}">
                {item}
            </label>
        </div>
    {/each}
</div>

<style>
    .grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
        gap: 8px;
    }

    .item {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
        padding: 6px 10px;
        border: 1px solid #ddd;
        border-radius: 3px;
        background: #fff;
        cursor: pointer;
        text-align: left;
        transition: background 0.15s ease, border-color 0.15s ease;
    }

    .item:hover {
        background: #f5f5f5;
    }

    .item.selected {
        background: #e8f0fe;
        border-color: #4a7fcb;
    }

    .icon {
        width: 36px;
        height: 36px;
        flex-shrink: 0;
        border-radius: 6px;
        overflow: hidden;
    }

    .icon img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .label {
        flex: 1;
        font-size: 13px;
        color: #1a1a1a;
    }

    .item.selected .label {
        color: #2a5cbf;
        font-weight: 500;
    }

    .check {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 16px;
        height: 16px;
        flex-shrink: 0;
        border: 1px solid #bbb;
        border-radius: 50%;
        background: #fff;
    }

    .item.selected .check {
        background: #4a7fcb;
        border-color: #4a7fcb;
    }

    .check-inner {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #fff;
        opacity: 0;
    }

    .item.selected .check-inner {
        opacity: 1;
    }
</style>